import './ErrorScreen.scss';

import serverTimedOut from '../../images/server-timed-out.svg';

import React, {useMemo} from 'react';

import {UNKNOWN_ERROR} from '../utils/ErrorUtil';

import {UnsecuredLogo} from './UnsecuredLogo/UnsecuredLogo';
import {ErrorView} from './views/ErrorView/ErrorView';
import {AppButton} from './ui';

interface ErrorScreenProps {
    message?: string;
    status?: number;
    terminal?: boolean;
    callback?: () => void;
}

const GENERIC_MESSAGE =
    'The server encountered an unexpected condition which prevented it from fulfilling the request.';

const ErrorScreen = ({
    message,
    status,
    terminal = false,
    callback = () => window.location.reload(),
}: ErrorScreenProps) => {
    const statusMessage = useMemo((): string => {
        const messageMap: {[key: number]: string} = {
            403: 'You are not authorized to perform this request.',
            404: 'Requested resource is not found.',
            405: 'Request method is not supported.',
            408: 'The server timed out waiting for a response. Please check your internet connection.',
            409: 'Your session has expired. Reloading page. ',
            500:
                "We couldn't reach Kashable's servers. " +
                'Please check your internet connection and try again. ',
            503:
                'The server is currently unable to handle the request ' +
                'due to a temporary overloading or maintenance of the server.',
        };
        return status ? messageMap[status] : GENERIC_MESSAGE;
    }, [status]);

    return (
        <div className='error-screen'>
            <UnsecuredLogo />
            <div className='error-screen__wrap'>
                <ErrorView title={UNKNOWN_ERROR} icon={serverTimedOut}>
                    <p className='text' dangerouslySetInnerHTML={{__html: message || statusMessage}}></p>
                    <div className='error-button'>
                        <AppButton action='error-try-again' disabled={terminal} onClick={callback}>
                            Try Again
                        </AppButton>
                    </div>
                </ErrorView>
            </div>
        </div>
    );
};

export default ErrorScreen;
